import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class Servis {


  constructor(public http: Http) {

  }

  makePostRequest(servisAdresi: string, postData: any) {
    return new Promise((resolve, reject) => {
      this.http.post(servisAdresi, postData).map(res => res.json())
        .subscribe(data => {
          resolve(data);
        }, (error) => {
          reject(error);
        });
    });
  };

  makePostRequestWithoutJsonResult(servisAdresi: string, postData: any) {
    return new Promise((resolve, reject) => {
      this.http.post(servisAdresi, postData)
        .subscribe(data => {
          resolve(data);
        }, (error) => {
          reject(error);
        });
    });
  };

  makeGetRequest(servisAdresi: string) {
    return new Promise((resolve, reject) => {
      this.http.get(servisAdresi).map(res => res.json())
        .subscribe(data => {
          resolve(data);
        }, (error) => {
          reject(error);
        });
    });
  }

  makeGetRequestWithoutJsonResult(servisAdresi: string) {
    return new Promise((resolve, reject) => {
      this.http.get(servisAdresi)
        .subscribe(data => {
          resolve(data);
        }, (error) => {
          reject(error);
        });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/servis.ts